export default __webpack_public_path__ + "static/media/picture.9b51200f.png";